import { createSlice } from '@reduxjs/toolkit';
import { Collection } from '@/types/collection';
import { getCollectionByShareToken } from './actions';

type CollectionStateProps = {
  isLoading: boolean;
  collection: Collection | null;
};

const initialState: CollectionStateProps = {
  isLoading: true,
  collection: null,
};

export const collectionSlice = createSlice({
  name: 'collection',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getCollectionByShareToken.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getCollectionByShareToken.fulfilled, (state, actions) => {
      state.collection = actions.payload;
      state.isLoading = false;
    });
    builder.addCase(getCollectionByShareToken.rejected, (state) => {
      state.isLoading = false;
    });
  },
  selectors: {
    selectIsLoading: (state) => state.isLoading,
    selectCollection: (state) => state.collection,
  },
});

export const {} = collectionSlice.actions;
export const { selectCollection, selectIsLoading } = collectionSlice.selectors;
